import React, { useRef } from 'react'
import { Table, TreeNavigation } from 'react-unity';
import WorkflowStateBadge from '../common/WorkflowStateBadge';
import CloudAccount from '../../models/CloudAccount';
import { authenticatedUser } from '../../authentication/authModule';
import moment from 'moment';
import { UserRole } from '../../models/enums/UserRole';
import { WorkflowState } from '../../models/enums/WorkflowState';
import ActionRow from '../common/tables/ActionRow';


interface CloudAccountsHomeTableRowProps {
    cloudAccount: CloudAccount;
    actionsEnabled: boolean;
    setResetPasswordModalVisible: any;
    setSelectedCloudAccount: any;
    setResetMfaModalVisible: any;
    setDeleteAccountModalVisible: any;
    setApproveModalVisible: any;
    setRejectModalVisible: any;
    setReasonModalVisible: any;
}

const CloudAccountsHomeTableRow = ({
    cloudAccount,
    actionsEnabled,
    setResetPasswordModalVisible,
    setSelectedCloudAccount,
    setResetMfaModalVisible,
    setDeleteAccountModalVisible,
    setApproveModalVisible,
    setRejectModalVisible,
    setReasonModalVisible
}: CloudAccountsHomeTableRowProps) => {

    const actionRef = useRef<HTMLButtonElement>(null);

    return (
        <ActionRow
            key={cloudAccount.id}
            actionRef={actionRef}
            actionCell={
                cloudAccount.createdUserPrincipalName
            }
            actions={
                actionsEnabled &&
                <TreeNavigation>
                    {cloudAccount.workflowInstance.currentWorkflowInstanceState.workflowState.name === WorkflowState.Approved.name &&
                        <>
                            <TreeNavigation.Item
                                label='Open in Azure'
                                onClick={() => {
                                    window.open(
                                        `https://portal.azure.cn/#blade/Microsoft_AAD_IAM/UserDetailsMenuBlade/Profile/userId/${cloudAccount.createdUserPrincipalName}`,
                                        '_blank'
                                    );
                                    actionRef.current.click();
                                }}
                            />
                            <TreeNavigation.Item
                                label='Reset Password'
                                onClick={() => (
                                    setResetPasswordModalVisible(true),
                                    setSelectedCloudAccount(cloudAccount)
                                )}
                            />

                            {false && !cloudAccount.createdUserPrincipalName.endsWith("@xomservices.com") && cloudAccount.canResetMFA &&
                                <TreeNavigation.Item
                                    label='Reset MFA Configuration'
                                    onClick={() => (
                                        setResetMfaModalVisible(true),
                                        setSelectedCloudAccount(cloudAccount)
                                    )}
                                />}

                            <TreeNavigation.Item
                                label='Delete Account'
                                onClick={() => (
                                    setDeleteAccountModalVisible(true),
                                    setSelectedCloudAccount(cloudAccount)
                                )}
                            />
                        </>}
                    {cloudAccount.workflowInstance.currentWorkflowInstanceState.workflowState.name === WorkflowState.Submitted.name && (cloudAccount.approver == authenticatedUser.userEmail ||
                        (authenticatedUser.isInRole(UserRole.CloudAccountAdmin) && !cloudAccount.approver)) &&
                        <>
                            <TreeNavigation.Item
                                label='Approve'
                                onClick={() => (
                                    setApproveModalVisible(true),
                                    setSelectedCloudAccount(cloudAccount)
                                )}
                            />
                            <TreeNavigation.Item
                                label='Reject'
                                onClick={() => (
                                    setRejectModalVisible(true),
                                    setSelectedCloudAccount(cloudAccount)
                                )}
                            />
                        </>}
                    <TreeNavigation.Item
                        label='View Request Information'
                        onClick={() => (
                            setReasonModalVisible(true),
                            setSelectedCloudAccount(cloudAccount)
                        )}
                    />
                </TreeNavigation>
            }
        >
            <Table.Body.Cell className='em-u-text-align-center'>
                <WorkflowStateBadge
                    workflowState={cloudAccount.workflowInstance.currentWorkflowInstanceState.workflowState}
                    fullWidth
                />
            </Table.Body.Cell>
            <Table.Body.Cell className='em-u-text-align-center'>
                {cloudAccount.approver ?
                    cloudAccount.approver
                    : "Entra ID Team"}
            </Table.Body.Cell>
            <Table.Body.Cell className='em-u-text-align-center'>
                {authenticatedUser.isInRole(UserRole.CloudAccountAdmin)
                    ? cloudAccount.workflowInstance.createdBy.displayName
                    : cloudAccount.workflowInstance.currentWorkflowInstanceState.performedByUser.displayName}
            </Table.Body.Cell>
            <Table.Body.Cell className='em-u-text-align-center'>{moment(new Date(cloudAccount.workflowInstance.createdDate)).format('MM/DD/YYYY')}</Table.Body.Cell>
        </ActionRow>
    )
};

export default CloudAccountsHomeTableRow;